import { Button } from "@/components/ui/button";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";
import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/use-language";

const CTA = () => {
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();
  const { ref: contactRef, isVisible: contactVisible } = useScrollAnimation();
  const { t, localePath } = useLanguage();

  return (
    <section id="contact" className="py-32 lg:py-44 gradient-hero relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gold/15 rounded-full blur-[120px] translate-x-1/2 -translate-y-1/2 animate-float" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gold/10 rounded-full blur-[100px] -translate-x-1/2 translate-y-1/2 animate-float" style={{ animationDelay: "3s" }} />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:60px_60px]" />
      </div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div ref={contentRef} className={`text-center mb-12 transition-all duration-700 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-normal text-white mb-6">
              {t("Redo att förenkla er", "Ready to simplify your")}{" "}
              <span className="italic gradient-text">{t("koncernredovisning?", "group accounting?")}</span>
            </h2>
            <p className="text-lg md:text-xl text-white/60 max-w-2xl mx-auto leading-relaxed">
              {t(
                "Boka en personlig demo och se hur TGA och TLE kan effektivisera ert arbete med koncernredovisning och leasinghantering.",
                "Book a personal demo and see how TGA and TLE can streamline your work with group accounting and lease accounting."
              )}
            </p>
          </div>

          <div className={`flex flex-col sm:flex-row gap-4 justify-center mb-16 transition-all duration-700 delay-100 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Link to={localePath("/book-a-demo")}>
              <Button variant="hero" size="xl">
                {t("Boka en personlig demo", "Book a personal demo")}
                <ArrowRight className="h-5 w-5" />
              </Button>
            </Link>
            <Link to={localePath("/support")}>
              <Button variant="heroOutline" size="xl">
                {t("Kontakta oss", "Contact us")}
              </Button>
            </Link>
          </div>

          <div ref={contactRef} className={`grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-xl mx-auto transition-all duration-700 delay-200 ${contactVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <a href="tel:+46812136801" className="flex items-center gap-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 hover:bg-white/10 hover:border-white/20 transition-all duration-300 group">
              <div className="w-12 h-12 rounded-xl bg-gold/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <Phone className="h-5 w-5 text-gold" />
              </div>
              <div>
                <div className="text-white/50 text-sm mb-0.5">{t("Ring oss", "Call us")}</div>
                <div className="text-white font-medium">+46 8 1213 68 01</div>
              </div>
            </a>
            <a href="mailto:support@tiego.se" className="flex items-center gap-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 hover:bg-white/10 hover:border-white/20 transition-all duration-300 group">
              <div className="w-12 h-12 rounded-xl bg-gold/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <Mail className="h-5 w-5 text-gold" />
              </div>
              <div>
                <div className="text-white/50 text-sm mb-0.5">{t("Maila oss", "Email us")}</div>
                <div className="text-white font-medium">support@tiego.se</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
